
/**
 * @license 
 * Copyright Google Inc. All Rights Reserved.
 * 
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 * @abstract
 */
export abstract class AnimationStyleNormalizer {
/**
 * @abstract
 * @param {?} propertyName
 * @param {?} errors
 * @return {?}
 */
normalizePropertyName(propertyName: string, errors: string[]) {}
/**
 * @abstract
 * @param {?} userProvidedProperty
 * @param {?} normalizedProperty
 * @param {?} value
 * @param {?} errors
 * @return {?}
 */
normalizeStyleValue(
      userProvidedProperty: string, normalizedProperty: string, value: string|number,
      errors: string[]) {}
}
export class NoOpAnimationStyleNormalizer {
/**
 * @param {?} propertyName
 * @param {?} errors
 * @return {?}
 */
normalizePropertyName(propertyName: string, errors: string[]): string { return propertyName; }
/**
 * @param {?} userProvidedProperty
 * @param {?} normalizedProperty
 * @param {?} value
 * @param {?} errors
 * @return {?}
 */
normalizeStyleValue(
      userProvidedProperty: string, normalizedProperty: string, value: string|number,
      errors: string[]): string {
    return /** @type {?} */(( <any>value));
  }
}
